import { bankServices } from "../../config/axios";
import {
    BANKMASTERLIST_SUCCESS,
    BANKMASTERLIST_FAILED,
    RESET_BANKMASTERLIST,
    LOADING_BANKMASTERLIST,
    BANKMASTERLIST_NETWORKERROR,
} from '../types/index';

const resetbankMasterList = () => {
    return { type: RESET_BANKMASTERLIST };
};

const bankMasterList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BANKMASTERLIST });
    await bankServices
        .post("bankmasterlist", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: BANKMASTERLIST_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: BANKMASTERLIST_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: BANKMASTERLIST_FAILED,
        payload: data
    };
}

export { resetbankMasterList, bankMasterList }